// How much difference an idea would make. Stored as the number, so the order (biggest first) can be
// compared and sorted; ideas submitted before it was asked have none.
export const IDEA_IMPACTS = {
  HIGH: 0,
  MEDIUM: 1,
  LOW: 2,
  VERY_LOW: 3,
} as const;

export type IdeaImpact = (typeof IDEA_IMPACTS)[keyof typeof IDEA_IMPACTS];

export const IDEA_IMPACT_VALUES = Object.values(IDEA_IMPACTS) as IdeaImpact[];

// Short wording for the idea page, admin panel, edit history and CSV.
export const IDEA_IMPACT_LABELS: Record<IdeaImpact, string> = {
  [IDEA_IMPACTS.HIGH]: 'High',
  [IDEA_IMPACTS.MEDIUM]: 'Medium',
  [IDEA_IMPACTS.LOW]: 'Low',
  [IDEA_IMPACTS.VERY_LOW]: 'Very low',
};

// What each level means, shown next to the label on the submit form.
export const IDEA_IMPACT_DESCRIPTIONS: Record<IdeaImpact, string> = {
  [IDEA_IMPACTS.HIGH]: 'saves or makes money, keeps customers or employees, or unblocks work',
  [IDEA_IMPACTS.MEDIUM]: 'saves time every week, or makes customers or employees happier',
  [IDEA_IMPACTS.LOW]: 'small time saving or an easier way to work',
  [IDEA_IMPACTS.VERY_LOW]: 'nice to have, little change to results',
};
